module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Sport Aluminum + Blue Open.6015b644.png";